<!--
================================================
Un composant afficher dans la section réglage qui prend la forme d'un bloc de formulaire mais qui est juste un lien vers la page subscription

Url d'accès : http://localhost:8080/fr/hotjar-inc/user/settings
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div id="C2aSubscriptionSettingsComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

    <div class="formSection " id="ctaSubscriptionSettingsLink">

      <div class="spacer">

        <div class="contTitle has-text-left">
          <h3 class="">
            <font-awesome-icon class="icon" :icon="['fas', 'medal']"/>
            {{ $t('Abonnement') }}
          </h3>
          <p class="help">{{ $t('AccédezAuxRéglagesDeVotreAbonnement') }}</p>
          <br>
          <router-link id="" class="button"
                       v-bind:to="{ name: 'workspace-subscription',params:{locale:locale,organization:organization, workspace:$auth.getActiveWorkspace()},query:{cycle:'month',pgr:planGroup4Locale}}">
            <span>{{ $t('GérerLAbonnement') }}</span>
            <font-awesome-icon class="icon" :icon="['fas', 'long-arrow-alt-right']"/>
          </router-link>

        </div>


      </div>

    </div>


  </div>


</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
import i18nMixin from "@/mixins/i18nMixin";

export default {
  name: 'C2aSubscriptionSettingsComp', //utile dans vue dev tool
  mixins: [i18nMixin],
  // components: {},


  // props: {
  // },
  // },
  data: function () {
    return {
      locale: this.$route.params.locale,
      organization: this.$route.params.organization,
    }
  },

  computed: {
    // computed props for store :
    ...mapState({
      user: state => state.user,
      themeToDisplay: state => state.app.themeToDisplay
    }),


  },


  methods: {},

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {
  },
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/css/globalVar.scss";
/*@import "../assets/css/bulmaResponsiveDep.scss";*/

#C2aSubscriptionSettingsComp {

  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////

  .button {
    padding: 1.2rem;
    font-size: .9rem;
    font-weight: bold;
    color: #666;

    .icon {
      //margin-left: .3rem;
      font-size: .7rem;
      color: $brandPrimary;
    }
  }

  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {
    .button {
      background-color: $darkBg2;
      color: $darkContrastTxt;
      border-color: $darkFieldBorder;
    }
  }

}
</style>
